import {UploadedFile} from '@interfaces/file.interface';

export namespace LaboratoryDocumentsNamespace {
    export interface DocumentApiData {
        id: number;
        type: DocumentTypeEnum;
        custom_name: string;
        number: string;
        date_issue: string;
        date_end: string;
        organization: string;
        files: UploadedFile[];
    }

    /**
     * Типы документов
     */
    export enum DocumentTypeEnum {
        /**
         * Свидетельство об аттестации
         */
        attestation = 1,
        /**
         * Лицензия на право использования источников ионизирующего излучения
         */
        iiiLicense = 2,
        /**
         * Санитарно-эпидемиологическое заключение;
         */
        sanitation = 3,
        /**
         * Лицензия ростехнадзора
         */
        rostehLicense = 4,
        /**
         * Свой документ
         */
        custom = -1
    }
}
